import { Placement } from 'src/constants/recommendations';
import { RichRelevancePlacements } from 'src/redux/richRelevance';
import { PageType } from 'src/types';
import { ReduxApplicationState } from '../combinedReducer';

const placementPageTypeMap = {
  category: Placement.CategoryListingsRecentlyViewed,
  search: Placement.SearchListingsRecentlyViewed,
  partner: Placement.PartnerListingsRecentlyViewed,
};

export const getRecentlyViewedPlacementFromPageType = (state: ReduxApplicationState) =>
  placementPageTypeMap[
    state.navigation.pageType ?? PageType.Category
  ] as keyof RichRelevancePlacements;
